<div class="hero-event-list-filters-content">
  <mat-form-field
    class="full-width-input filter-item"
  >
    <mat-label
    >Search</mat-label
    >
    <input matInput [formControl]="searchControl" />
  </mat-form-field>

  <app-autocomplete
    label="Filter By Event Category"
    placeholder=""
    [options]="eventCategoryOptions"
    (selectionChange)="onFilterChange($event, 'eventCategoryId')"
    class="full-width-input filter-item"
  />

  <mat-slide-toggle
    [color]="'primary'"
    class="filter-item"
    (toggleChange)="filters.active = !filters.active; filtersUpdated.emit(filters)"
  >
    Show Inactive
  </mat-slide-toggle>
</div>
